export default __webpack_public_path__ + "static/former-avrundet-rektangulaere1-220e838dc64785810ec7fd08fb221065.png";